import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import PopEdit from "./components/PopEdit";
import PopEditSettings from "./components/PopEditSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/popedit_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'popEdit',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_POPEDIT'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        allowClear: true,
        bordered: true,
        dataTextField: 'name',
        dataValueField: 'value',
        inputProps: {
        },
        modalProps: {
          width: document.body.clientWidth / 2,
          bodyStyle: {
            height: (document.body.clientHeight * 7) / 10 - 81.6
          },
          title: '测试title',
          render: 'https://fish.iwhalecloud.com/remote-components/popeditmodal.js',
          onOk: () => { },
        },
        // formProps: {}
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_POPEDIT'],
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: PopEdit, // 插件渲染组件
    pluginSettingComponent: PopEditSettings, // 插件设置项组件
  }
}
